import InputAdornment from '@mui/material/InputAdornment';
import './ArrNumericInput.scss';
import ArrTextField from '../arr-text-field/ArrTextField';
import {Box} from '@mui/material';
import {ErrorOutline} from '@mui/icons-material';

export interface NumericPercentInputProps {
  value?: number;
  onChange?: (newValue?: number) => void;
  min?: number;
  max?: number;
  disabled?: boolean;
  ariaLabel?: string;
  placeholder?: string;
  sizeVariant?: 'large' | 'medium' | 'small';
  dataTestId: string;
  showPercentage?: boolean;
  minWidth?: string | number;
  supportText?: string;
  label?: React.ReactNode;
  isError?: boolean;
}

const ArrNumericInput: React.FC<NumericPercentInputProps> = ({
  value,
  onChange,
  min,
  max,
  disabled = false,
  ariaLabel,
  sizeVariant = 'small',
  dataTestId = 'numeric-input',
  showPercentage = true,
  minWidth,
  isError = false,
  ...rest
}) => {
  const clamp = (val: number) => {
    //only if min or max are provided
    let newValue = val;
    if (typeof min === 'number') newValue = Math.max(min, newValue);
    if (typeof max === 'number') newValue = Math.min(max, newValue);
    return newValue;
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value.trim();
    if (raw === '') {
      onChange?.(undefined);
      return;
    }
    let newValue = Number(raw);
    if (!isNaN(newValue)) {
      newValue = clamp(newValue);
      onChange?.(newValue);
    }
  };

  return (
    <Box className="arr-numeric-input-wrapper">
      <ArrTextField
        value={value ?? ''}
        onChange={handleChange}
        disabled={disabled}
        aria-label={ariaLabel || 'Numeric Percent Input'}
        sizeVariant={sizeVariant}
        className="arr-numeric-input"
        inputMode="numeric"
        state={disabled ? 'inactive' : isError ? 'error' : 'enabled'}
        dataTestId={dataTestId}
        slotProps={{
          input: {
            role: 'presentation',
            type: 'text',
            'data-testid': `${dataTestId}-field`,
            inputProps: {
              inputMode: 'numeric',
              pattern: '[0-9]*',
              'aria-label': ariaLabel || 'Numeric Percent Input',
              'data-testid': dataTestId,

              title: '',
              className: 'numeric-input-field',
              style: {
                minWidth: minWidth,
                paddingRight: '0.5rem',
              },
            },
            endAdornment: showPercentage ? (
              <InputAdornment position="end" className="percent-sign">
                %
              </InputAdornment>
            ) : isError ? (
              <ErrorOutline />
            ) : null,
          },
        }}
        {...rest}
      />
    </Box>
  );
};

export default ArrNumericInput;
